import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NzIconModule, NzStepsModule, NzTableModule, NzTabsModule, NzUploadModule} from 'ng-zorro-antd';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {WebcamModule} from 'ngx-webcam';
import { EkycCameraComponent } from './ekyc-camera.component';


@NgModule({
  declarations: [
    EkycCameraComponent
  ],
  imports: [
      CommonModule,
      TranslateModule,
      MaterialModule,
      SharedModule,
      FormsModule,
      ReactiveFormsModule,
      NzStepsModule,
      NzTableModule,
      NzTabsModule,
      NzUploadModule,
      NgxExtendedPdfViewerModule,
      NzIconModule,
      WebcamModule
  ],
  entryComponents: [],
  exports: [
    EkycCameraComponent
  ]
})
export class EkycCameraModule { }
